import { palette, typography } from "@src/core/styles";
import styled from "styled-components";

export const RoutesPageContainer = styled.div`
  display: flex;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Text = styled.div`
  ${typography.body_large_regular};
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 696px;
  & a {
    color: ${palette.colors.link};
    &:hover {
      color: ${palette.colors.green_base};
    }
  }
`;
